import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: '3834480a-954f-405f-aa20-71e23d719570',
        authority: 'https://login.microsoftonline.com/64c47e2c-9101-4dd0-9d5d-294d60d9e247',
        redirectUri: window.location.origin,
        //redirectUri: "http://localhost:3000"
    },
};

var msalInstance = undefined;
var initialized = false;
var currentAccount = undefined;

async function Initialize(force){
    if (!initialized || force === true) {
        msalInstance = new PublicClientApplication(msalConfig);
        await msalInstance.initialize()
    }
        
}

async function GetAuthToken(scopes) {

    return new Promise(async (resolve, reject) => {
        await Initialize();

        var accounts = msalInstance.getAllAccounts();
        
        if (accounts.length > 0 && currentAccount !== undefined) {
            console.log("Accounts:" + JSON.stringify(accounts))
            msalInstance.acquireTokenSilent({ scopes })
                .then(response => {
                    currentAccount = response.account;
                    resolve(response.accessToken)
                    console.log("logged in with cache." /*+ JSON.stringify(res)*/);
                })
                .catch((err) => console.log("not logged in with cache" + err));
        }
        msalInstance.acquireTokenPopup({ scopes })
            .then(response => {
                currentAccount = response.account;
                resolve(response.accessToken)
                console.log("logged in.")
            })
            .catch((error) => {
                console.log("not logged in." + error);
                reject(error)
            });
     
    });
    
}

async function LogOut() {
    await Initialize();
    await msalInstance.logoutPopup()
        .then(res => console.log("logged out"))
        .catch((err) => console.log("not logged out" + err));
    
}

export { GetAuthToken, LogOut };